import { render, staticRenderFns } from "./AccountsAcountingEdit.vue?vue&type=template&id=40b817da&scoped=true&"
import script from "./AccountsAcountingEdit.vue?vue&type=script&lang=js&"
export * from "./AccountsAcountingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b817da",
  null
  
)

export default component.exports